import { observer } from "mobx-react"
import PageWrapper from "pages/Components/PageWrapper"
import CustomButton from 'base/ui/components/Button';
import { useState } from "react";
import BoxContainer from "base/ui/components/BoxContainer";
import { Form, message } from "antd";
import { POCreatRequest } from "models/PurchaseOrder";
import { nanoid } from "@ant-design/pro-components";
import { SYSTEM_TITLE } from "utils/constants";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "base/routes/routes";
import { purchaseOrderPresenter } from "stores/root_store";
import { MdSaveAs } from "react-icons/md";
import { IoMdSave } from "react-icons/io";
import General from "./General";
import PurchaseOrderTabel from "./PurchaseOrderTabel";
import { useCheckPermission, useCheckPermissionByUrl } from "utils/permissionHelper";
import dayjs from "dayjs";


export function createAddPurchaseOrder() {
    return observer(() => {
        document.title = 'Thêm mới - ' + SYSTEM_TITLE;
        useCheckPermissionByUrl(ROUTES.PURCHASE_ORDER.LIST_PO.LINK, "CREATE")
        const navigate = useNavigate()
        const [formCreate] = Form.useForm()
        const id = nanoid()
        const [editableKeys, setEditableRowKeys] = useState<React.Key[]>([id]);
        const [loading, setLoading] = useState(false)

        const handleCreate = async (values: POCreatRequest, isContinue?: boolean) => {
            const request = values.purchaseOrderItems?.map(p => ({ ...p, documentDate: dayjs(p.documentDate).format("YYYY-MM-DD[T]HH:mm:ss") }))
            setLoading(true)
            const response = await purchaseOrderPresenter.createPurchaseOrder({ ...values, purchaseOrderItems: request })
            setLoading(false)
            if (response.isSuccess) {
                message.success(response.message)
                if (isContinue) {
                    formCreate.resetFields()
                    setEditableRowKeys([id])
                } else {
                    navigate(ROUTES.PURCHASE_ORDER.LIST_PO.LINK)
                }
            } else {
                message.error(response.message)
            }
        }


        return (
            <PageWrapper breadcrumb={[{
                text: "Kế hoạch giao hàng",
                to: ROUTES.PURCHASE_ORDER.LIST_PO.LINK
            }, {
                text: 'Thêm mới'
            }
            ]}
                extras={
                    <>
                        <CustomButton
                            loading={loading}
                            disabled={loading}
                            onClick={() => {
                                formCreate.validateFields().then((value) => {
                                    handleCreate(value);
                                }).catch((error) => { console.log(error) })
                            }}
                            icon={<IoMdSave className="text-base" />}>
                            Lưu
                        </CustomButton>
                        <CustomButton
                            loading={loading}
                            disabled={loading}
                            type="primary"
                            icon={<MdSaveAs className="text-base" />}
                            onClick={() => {
                                formCreate.validateFields().then((value) => {
                                    handleCreate(value, true);
                                }).catch((error) => { console.log(error) })
                            }}
                        >
                            Lưu và tiếp tục thêm mới
                        </CustomButton>
                    </>
                }
            >
                <BoxContainer fullHeight className="!bg-transparent !p-0">
                    <Form
                        autoComplete="off"
                        initialValues={{ purchaseOrderItems: [{ purchaseOrderDetailId: id }] }}
                        layout="vertical"
                        form={formCreate}
                        className="flex flex-col gap-default"
                    >
                        <General form={formCreate} />
                        <PurchaseOrderTabel
                            editableKeys={editableKeys}
                            id={id}
                            setEditableRowKeys={setEditableRowKeys}

                        />
                    </Form>

                </BoxContainer>
            </PageWrapper>
        )
    })
}